<template>
  <div>
    <div class="is-flex">
      <div
        class="is-flex"
        v-tooltip="'Clic para ver los filtros'"
        v-on:click="activeMenu"
        style="margin-left: 10px;"
      >
        <a class="button is-small">Filtro histórico</a>
        <span
          class="tag is-link is-small"
          v-if="countFiltersActive"
          style="margin-left: -10px; bottom: 10px !important; font-size: 10px !important; position: relative;"
          >{{ countFiltersActive }}</span
        >
      </div>
    </div>
    <nav id="menuFilter" v-if="active" class="panel" style="width: 30%">
      <div class="panel-heading">
        <div class="is-size-5 is-flex">
          Filtros
          <div
            v-if="groups.length"
            class="tags has-addons"
            style="margin-left: 10px"
          >
            <span class="tag is-link">{{ groups.length }}</span>
          </div>
        </div>
        <button
          class="delete"
          aria-label="delete"
          v-on:click="activeMenu"
        ></button>
      </div>
      <div class="panel-block">
        <p class="control has-icons-left">
          <input
            class="input"
            type="text"
            v-model="search"
            placeholder="Buscar..."
          />
          <span class="icon is-left">
            <i class="material-icons">search</i>
          </span>
        </p>
      </div>
      <div class="panel-body truncate">
        <div v-for="(v, k) in filteredItems" :key="k" v-on:click="select(k)">
          <a class="panel-block" :class="{ 'is-active': v.active }">
            <span class="panel-icon">
              <input type="checkbox" :checked="v.active" :id="k" />
            </span>
            <span
              class="truncate"
              style="width: 100%"
              v-tooltip="{
                content: `<div>${v.value}</div>`,
                classes: ['tooltipName'],
              }"
              >{{ v.value }}</span
            >
          </a>
        </div>
      </div>
      <a v-if="!filteredItems.length" class="panel-block">
        <p>0 resultados</p>
      </a>
      <div class="panel-block is-flex">
        <button
          :disabled="!countFiltersActive"
          class="button is-link is-outlined"
          style="margin-right: 10px"
          v-on:click="setFilters()"
        >
          Aplicar filtro
        </button>
        <button
          :disabled="!countFiltersActive"
          class="button is-link is-outlined is-danger"
          v-on:click="deleteFilter()"
        >
          Eliminar filtro
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";
const filterItems = (query, data) => {
  return data.filter((el) => {
    const texto = el.value;
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};
export default {
  data() {
    return {
      groups: [],
      search: "",
      active: false,
      withFilter: false,
      countFiltersActive: 0,
    };
  },
  computed: {
    ...mapState(["isOculto", "isMovil"]),
    filteredItems: function() {
      return filterItems(this.search, this.groups);
    },
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  beforeMount() {
    this.groups = this.data;
  },
  methods: {
    activeMenu() {
      this.active ? (this.active = false) : (this.active = true);
    },
    select(k) {
      // Si es el mismo grupo se activa o desactiva
      this.groups[k].active = !this.groups[k].active;
    },
    setFilters() {
      const filter = this.getSelectFilters(this.groups);
      if (filter.length) {
        this.$emit("setFilterHistoric", filter);
        this.withFilter = true;
        this.activeMenu();
      }
    },
    deleteFilter() {
      this.groups.forEach((v, k) => {
        this.groups[k].active = false;
      });
      this.$emit("deleteFilterHistoric");
      this.withFilter = false;
      // this.activeMenu()
    },
    getSelectFilters() {
      return this.groups.filter((x) => x.active);
    },
    restartSelects() {
      this.groups.forEach((v, k) => {
        this.groups[k].active = false;
      });
      this.withFilter = false;
    },
  },
  watch: {
    groups: {
      handler() {
        this.countFiltersActive = this.getSelectFilters().length;
        if (!this.countFiltersActive && this.withFilter) {
          this.deleteFilter();
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.panel-heading {
  display: flex;
  justify-content: space-between;
}

#menuFilter {
  margin-top: 15px !important;
  background: white;
  position: absolute;
  z-index: 250;
  max-height: 360px !important;
}

#menuFilter .panel-body {
  max-height: 300px !important;
  overflow: auto;
}

#menuFilter .panel-block {
  background-color: white;
}

#menuFilter .is-active {
  border-left: solid 3px #41aae7;
  color: #363636;
  background: aliceblue;
}

.panel-block .panel-icon .material-icons {
  line-height: unset !important;
}

.tooltipName {
  z-index: 251;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/menuFiltersHistoric.vue